var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("\n    "+_vm._s(_vm.recipient.email)+" ("+_vm._s(_vm.recipient.name)+")\n  ")]),_vm._v(" "),(_vm.recipient.assistants && _vm.recipient.assistants.length > 0)?_c('p',{staticClass:"mt-1 is-size-7 has-text-grey is-italic"},[_vm._v("\n    "+_vm._s(_vm.$t('resourceNotificationsCreateModal.recipientsChooser.assistants_label', {
        assistants: _vm.recipient.assistants.map(assistant => assistant.email).join(', ')
      }))+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }